export enum PlatformStatusEnum {
  /**
   * Ожидает настройки
   * The platform is in draft state and awaits configuration.
   */
  DRAFT = 'draft',

  /**
   * На модерации
   * The platform is under moderation review.
   */
  MODERATION = 'moderation',

  /**
   * Работает
   * The platform is active and operational.
   */
  WORK = 'work',

  /**
   * Отключен
   * The platform is disabled.
   */
  DISABLED = 'disabled',

  /**
   * Отклонен модерацией
   * The platform was rejected by moderation.
   */
  REJECTED = 'rejected',

  /**
   * Не прошёл проверку по правилам
   * The platform failed the compliance check.
   */
  FAILED_RULES = 'failed_rules',

  /**
   * Нужно обновить бота
   * The bot needs to be updated.
   */
  BOT_UPDATE_REQUIRED = 'bot_update_required',

  /**
   * Удалена пользователем
   * The platform was soft-deleted by the owner.
   */
  DELETED = 'deleted',
}
